import * as React from 'react';
import '../ux_styles.css';
import MediaQuery from 'react-responsive';

interface Props {
    
}

export default class LandscapePage extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<MediaQuery orientation="landscape">
				{this.props.children}
			</MediaQuery>
		)
	}
}
